module.exports = __webpack_public_path__ + "img/milestone-asset-1-mobile.2af2f47f.png";